export const muiTabTheme = {
  MuiTab: {
    styleOverrides: {
      root: ({ theme }) => ({
        fontFamily: 'RF Rostin',
        letterSpacing: '-2px',
        fontSize: 22,
        padding: '12px',
        color: theme.palette.kit.text.secondary,
        '&.MuiButtonBase-root': {
          minHeight: 'auto',
        },
        '&.MuiButtonBase-root.Mui-selected': {
          color: theme.palette.kit.text.h,
        },
        [theme.breakpoints.down('sm')]: {
          letterSpacing: '-1px',
          fontSize: 12,
          padding: '5px',
        },
      }),
    },
  },
};
